var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex gap-2 snt-text-highlight"},[(_vm.text)?_vm._t("prepend"):_vm._e(),_c('div',{staticClass:"d-flex align-start",domProps:{"innerHTML":_vm._s(_vm.text)}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }